import { isFalsy } from "@/lib/helpers";

export interface DefaultFilter {
  name: string;
  default_value?: any;
}

// URL-global drill-through sentinel — see Reports/DatatableFilter.vue's
// setInitialFilters for the contract. When a caller (e.g., the Membership
// Health Dashboard) wants to bypass the report's filter defaults, it
// appends `from_dashboard=1` to the click-through URL. Every surface that
// applies defaults reads the rule from here so they cannot drift apart.
export const bypassesFilterDefaults = (params: Record<string, any> = {}) =>
  params.from_dashboard === "1";

export const getDefaultsToSet = (
  filters: DefaultFilter[] = [],
  params: Record<string, any> = {}
) => {
  if (bypassesFilterDefaults(params)) return {};

  const hasExistingFilterParam = filters.some(
    (f) => !isFalsy(params[f.name])
  );

  if (hasExistingFilterParam) return {};

  return filters.reduce((acc, filter) => {
    if (!isFalsy(filter.default_value) && isFalsy(params[filter.name])) {
      acc[filter.name] = filter.default_value ?? null;
    }
    return acc;
  }, {} as Record<string, any>);
};
